import { render, staticRenderFns } from "./price-ups-downs.vue?vue&type=template&id=694da65d&scoped=true&"
import script from "./price-ups-downs.vue?vue&type=script&lang=js&"
export * from "./price-ups-downs.vue?vue&type=script&lang=js&"
import style0 from "./price-ups-downs.vue?vue&type=style&index=0&id=694da65d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694da65d",
  null
  
)

export default component.exports